import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AgentService } from './agent.service';
import { AgentRoutingModule } from './agent-routing.module';
import { AccountSearchComponent } from './account-search/account-search.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatToolbarModule,
  MatSidenavModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSliderModule,
  MatCardModule,
  MatDatepickerModule,
  MatSlideToggleModule,
  MatOptionModule,
  MatTableModule,
  MatSortModule} from '@angular/material';
import { AgentDashboard } from './agent-dashboard/agent-dashboard-component';
import { AddServiceAccountComponent } from './agent-dashboard/add-service/add-service-account-component';
import { BillingSyncComponent } from './agent-dashboard/billing-sync/billing-sync-component';
import { ForgotAdminPasswordComponent, ChangeAdminPasswordSuccessLink } from './reset-password/forgot-password-component';
import { ResetAdminPasswordComponent, ChangePasswordSuccess } from './reset-password/reset-password-component';
import {AddEsiIdHold, FlagSearchComponent, RemoveEsiIdHold} from './agent-dashboard/flag-search/flag-search.component';
import { DppOverrideComponent } from './agent-dashboard/dpp-override/dpp-override.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChargeBackComponent} from './agent-dashboard/chargeback-process/chargeback-process.component';
import { SupDownloadComponent } from './sup-download/sup-download.component';

@NgModule({schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AgentRoutingModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSliderModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSidenavModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatOptionModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatSortModule
  ],
  exports:[
    MatTableModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatSortModule
  ],
  providers: [AgentService],
  declarations: [AccountSearchComponent, SupDownloadComponent, ChangeAdminPasswordSuccessLink, ChangePasswordSuccess, ResetAdminPasswordComponent,  ForgotAdminPasswordComponent, AgentDashboard, AddServiceAccountComponent,
    BillingSyncComponent, FlagSearchComponent, RemoveEsiIdHold, AddEsiIdHold, DppOverrideComponent, ChargeBackComponent, SupDownloadComponent],
  entryComponents: [ChangeAdminPasswordSuccessLink, ChangePasswordSuccess, RemoveEsiIdHold, AddEsiIdHold],
  bootstrap: [],
})
export class AgentModule { }



// WEBPACK FOOTER //
// ./src/app/agent/agent.module.ts